export const CORPORATE_SPARK_POST_MIGRATION_NOTICE_KEY =
  "corporate_spark_post_migration_notice_dismissed";

export const officialSparkMigrationLaunchDate = new Date(
  "2025-04-02T08:00:00Z"
); // April 2, 2025 4:00:00 AM EST
